import React from "react";
import {Subject, PowerInput} from "@material-ui/icons";

interface NavigationElement {
  title: string;
  icon?: JSX.Element;
  path: string;
}
export const navigationElements: Array<NavigationElement> = [
  {
    title: "Articles EN",
    path: "/sentiment/en",
    icon: <Subject />
  },
  {
    title: "Articles RU",
    path: "/sentiment/ru",
    icon: <Subject />
  },
  {
    title: "Tweets",
    path: "/sentiment/tweet",
    icon: <PowerInput />
  }
];
